import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledTagComponent } from "segments/desktop/careers/layouts/positions-careers/position/tag/tag-component.scss";
import PictureComponent from "components/core/picture/picture-component";
const TagComponent = ({ text, Icon })=>/*#__PURE__*/ _jsxs(StyledTagComponent, {
        children: [
            Icon && /*#__PURE__*/ _jsx("div", {
                className: "icon-container",
                children: /*#__PURE__*/ _jsx(Icon, {})
            }),
            /*#__PURE__*/ _jsx("span", {
                children: text
            })
        ]
    });
export default TagComponent;
